export function InvoiceReworkCtrl (
  $scope,
  $stateParams,
  $translate,
  $uibModalInstance,
  invoice,
  invoices,
  workshopAPI
) {

  $scope.invoice          = invoice;
  $scope.invoiceForRework = null;
  $scope.invoices         = invoices;

  $scope.tableSettings = {
    columns: [
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe    : 'globalDate',
        pipeArgs: 'mediumDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/invoices/reworkable_list_count', [
        $stateParams.customer_id,
        $stateParams.vehicle_id
      ])
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/invoices/reworkable_list', [
      $stateParams.customer_id,
      $stateParams.vehicle_id,
      params.offset,
      params.pageSize
    ])
    .then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.save = function () {
    $uibModalInstance.close({
      complaint    : $scope.invoice.rework_complaint,
      invoice_id   : $scope.invoice.id,
      reason       : $scope.invoice.rework_reason,
      rework_for_id: $scope.invoice.rework_for_id || $scope.invoiceForRework.id
    });
  };

  $scope.onRowClick = function ( invoice ) {
    if ($scope.invoiceForRework && invoice.id === $scope.invoiceForRework.id) {
      $scope.invoiceForRework = null;
    }
    else {
      $scope.invoiceForRework = invoice;
    }
  };
}